import React, { useContext } from "react";
import { FormControlLabel, Checkbox, Box, Typography } from "@mui/material";
import { getColors } from "../../../themes/theme";
import { ThemeContext } from "../../../context/ThemeContext";

export const CitationItem = ({ id, name, onCheck, isChecked, disabled }) => {
  const { darkMode } = useContext(ThemeContext);

  const handleCheckboxChange = (event) => {
    if (disabled) return; // Prevent click if disabled
    event.stopPropagation(); // Prevent the Box's onClick from being triggered

    onCheck(id, event.target.checked); // Notify parent about the change
  };

  return (
    <Box
      sx={{
        width: "100%",
        px: { xs: 2, sm: "20px", md: 2, lg: "20px" },
        py: "12px",
        borderRadius: "5px",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: !disabled
          ? darkMode
            ? getColors.thumbnailBorderDark
            : getColors.thumbnailBorderLight
          : darkMode
          ? "#FFFFFF"
          : "#000000",
        background: darkMode
          ? getColors.thumbnnailBgDark
          : getColors.thumbnnailBgLight,
        cursor: !disabled && "pointer",
        "&:hover": !disabled && {
          borderColor: darkMode
            ? getColors.thumbnailTextDark
            : getColors.thumbnailTextLight,
        },
      }}
      onClick={() => {
        !disabled && onCheck(id, !isChecked);
      }} // Notify parent when clicked
    >
      <Box
        display={"flex"}
        justifyContent="space-between"
        sx={{ alignItems: "center" }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            color: !disabled
              ? darkMode
                ? getColors.drawerTextDark
                : getColors.thumbnailTextLight
              : darkMode
              ? "#bbbbbb99"
              : "#22222299",
            fontWeight: 500,
            textAlign: "left",
          }}
        >
          {name}
        </Typography>
        <FormControlLabel
          sx={{ margin: 0 }}
          control={
            <Checkbox
              checked={isChecked} // Use the isChecked prop to control the checkbox state
              onChange={handleCheckboxChange} // Allow manual toggling
              disabled={disabled} // Disable the checkbox if the item is disabled
              sx={{
                "&.Mui-checked": {
                  color: "inherit",
                },
              }}
            />
          }
        />
      </Box>
    </Box>
  );
};
